import { GET_ABC_BY_ID_SUCCESS, GET_ABCS_SUCCESS } from './abc.types';

const initialState = {
    abcList: [],
    abcById: null,
};

export const abcReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Assessment */

        case GET_ABCS_SUCCESS:
            return {
                ...state,
                abcList: action.payload,
            };

        case GET_ABC_BY_ID_SUCCESS:
            return {
                ...state,
                abcById: action.payload,
            };

        /** End */

        default:
            return state;
    }
};
